<template>
    <div class="p-mt-3">
        <h5 class="p-mt-0">
            {{ t("job.preferences.salary") }}
        </h5>
        <span class="p-float-label">
            <InputNumber
                v-model="v$.desiredSalary.$model"
                mode="currency"
                currency="EUR"
                locale="de-DE"
                :class="{ 'p-invalid': v$.desiredSalary.$error }"
                data-cy="wizard-salary"
            />
            <label>{{ t("registration.tech.salary") }}</label>
        </span>
        <small class="p-error" v-for="(error, index) of v$.desiredSalary.$errors" :key="index">
            {{ t(error.$message) }}
        </small>
    </div>
    <div class="p-mt-3">
        <span class="p-float-label">
            <InputNumber
                v-model="v$.desiredSalaryBonus.$model"
                mode="currency"
                currency="EUR"
                locale="de-DE"
                :class="{ 'p-invalid': v$.desiredSalaryBonus.$error }"
                data-cy="wizard-bonus"
            />
            <label>{{ t("registration.tech.bonus") }}</label>
        </span>
        <small class="p-error" v-for="(error, index) of v$.desiredSalaryBonus.$errors" :key="index">
            {{ error.$message }}
        </small>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from "vue";
import { useI18n } from "vue-i18n";
import { helpers, minValue } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import InputNumber from "primevue/inputnumber";

const props = defineProps(["candidate", "step"]);
const user = ref(props.candidate);
const { t } = useI18n();

const rules = computed(() => {
    return {
        desiredSalary: {},
        desiredSalaryBonus: {
            minValue: helpers.withMessage(t("validate.minvalueorempty.error", { value: 500 }), minValue(500)),
        },
    };
});
const v$ = useVuelidate(rules, user);

onMounted(async () => {});
</script>

<style scoped>
.p-inputnumber.p-component.p-inputwrapper.p-inputwrapper-filled,
.p-inputnumber.p-component.p-inputwrapper {
    width: 100%;
}

.p-float-label > span ~ label {
    top: 50% !important;
    left: 0.5rem !important;
}

.p-float-label .p-inputwrapper-focus ~ label,
.p-float-label .p-inputwrapper-filled ~ label {
    top: 10px !important;
    left: 15px !important;
}

.p-float-label .p-inputwrapper-focus ~ label {
    top: 10px !important;
    left: 15px !important;
}
</style>
